import { CheckboxItem, CheckboxListItem } from "./CheckBoxListItem";

export type CheckboxListInnerProps = {
    items: CheckboxItem[];
    selectedValues: string[];
    onChange: (value: string[]) => void;
};

export const CheckboxListInner = (props: CheckboxListInnerProps) => {
    const { items, selectedValues, onChange } = props;

    const onToggle = (item: CheckboxItem, value: boolean) => {
        const otherSelectedValues = selectedValues.filter((value) => value !== item.value);

        if (value) {
            onChange([...otherSelectedValues, item.value]);
        } else {
            onChange(otherSelectedValues);
        }
    };

    const isSelected = (item: CheckboxItem) => selectedValues.indexOf(item.value) > -1;

    return (
        <>
            {items.map((item) => (
                <CheckboxListItem
                    key={item.value}
                    item={item}
                    checked={isSelected(item)}
                    onToggle={(checked) => onToggle(item, checked)}
                />
            ))}
        </>
    );
};
